module.exports = __webpack_public_path__ + "static/media/co2cloud-new.c8bc256f.svg";